import { QueryClient, isServer } from '@tanstack/react-query'
import { cache } from 'react'
import { getPriceColumn } from './priceColumn'

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000
      }
    }
  })
}

let browserQueryClient: QueryClient | undefined
let browserPriceColumn: string | undefined

/** One QueryClient per server request — never share across requests. */
const getServerQueryClient = cache(() => makeQueryClient())

export function getQueryClient() {
  if (isServer) {
    return getServerQueryClient()
  }

  const currentPriceColumn = getPriceColumn()
  if (!browserQueryClient || browserPriceColumn !== currentPriceColumn) {
    browserQueryClient = makeQueryClient()
    browserPriceColumn = currentPriceColumn
  }

  return browserQueryClient
}
